const mapDocument = (doc, restProps) => {
    return {
		documentId: doc.id,
		documentName: doc.documentName,
		documentTypeId: doc.documentTypeId,
		engagementId: doc.engagementId,
		...restProps
	};
};


export default (response, restProps) => response?.data?.map(doc => mapDocument(doc, restProps)) ?? [];